import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';

@inject(State, Router)
export class PortalWaiting {
	globalState: State;
	router: Router;

	constructor(state: State, router: Router) {
		this.globalState = state;
		this.router = router;
	}

	attached() {
		if (!this.router.currentInstruction.fragment && this.globalState.business) {
			if (this.globalState.business.portalSettings.businessSettings.allowEzpay) {
				if (this.globalState.business.portalSettings.ezpay.ezpayOnly) {
					let _this = this;
					setTimeout(function () {
						_this.router.navigateToRoute('ezpay');
					}, 0);
				} else {
					let _this = this;
					setTimeout(function () {
						_this.router.navigateToRoute('login');
					}, 0);
				}
			} else {
				let _this = this;
				setTimeout(function () {
					_this.router.navigateToRoute('login');
				}, 0);
			}
		}
	}
}
